import _ from 'lodash'
import dayjs from 'dayjs'

// Gộp phẳng danh sách lịch trình (mỗi phần tử là 1 "khai báo" Timetable với nhiều
// timetable_details) thành 1 mảng buổi học đơn, sắp theo thời gian.
// - GIỮ NGUYÊN notes riêng của từng buổi (detail.notes), KHÔNG lấy nhầm notes cấp
//   lịch trình cha (bug cũ đã gặp ở MyClassSessionsPanel).
// - teacher/subject/is_holiday: kéo từ Timetable cha xuống để hiển thị ở dòng buổi.
// - Ngày nghỉ là 1 phase song song với buổi thường cùng ngày -> ưu tiên bản ghi nghỉ.
export const flattenTimetable = (data = []) => {
    const raw = _.flatMap(data, (m) =>
        (m?.timetable_details || []).map((detail) => ({
            ...detail,
            teacher: m?.teacher,
            subject: m?.subject,
            is_holiday: m?.is_holiday,
            date_key: dayjs(detail?.start_time).format('YYYY-MM-DD'),
        }))
    )
    return _.chain(raw)
        .groupBy('date_key')
        .flatMap((group) => {
            const holidays = group.filter((e) => e.is_holiday === 1)
            return holidays.length ? holidays : group
        })
        .sortBy((e) => dayjs(e.start_time).valueOf())
        .value()
}
